// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const CvssModifiedAttackRequirementsSchema = z.enum(['X','N','P'] as const);

export type CvssModifiedAttackRequirementsType = `${z.infer<typeof CvssModifiedAttackRequirementsSchema>}`

export default CvssModifiedAttackRequirementsSchema;
